export enum EqualizeFeatureEnum {
  MULTI_MATCH_SEARCH = 'multiMatchSearch',
  SEMANTIC_MATCH_SEARCH = 'semanticMatchSearch',
  BOOSTING = 'boosting',
  FUNCTION_SCORE = 'functionScore',
  SPONSORED_SCORE = 'sponsoredScore',
}
